import { lt } from '@mews/framework';
import { Stack, Title } from '@optimus-web/core';
import { SchemaFormDefinition, SchemaFormFields } from '@mews-commander/form';
import { emailSchema } from '../schema';
import { MAX_CHARACTER_COUNT_SUBJECT, MAX_CHARACTER_COUNT_MESSAGE } from '../constants';
import { GenerateContractFormStepName, RecipientsFormFields } from '../types';

const emailFormDefinition: SchemaFormDefinition<typeof emailSchema> = {
    fields: {
        subject: {
            label: lt('ContractsGenerateContractEmailSubjectLabel'),
            field: {
                type: 'text',
                maxCharacterCount: MAX_CHARACTER_COUNT_SUBJECT,
            },
        },
        message: {
            label: lt('ContractsGenerateContractEmailMessageLabel'),
            field: {
                type: 'textarea',
                rows: 1,
                maxCharacterCount: MAX_CHARACTER_COUNT_MESSAGE,
            },
        },
    },
};
export const AddEmailSection = () => {
    return (
        <Stack vertical spacing="200">
            <Title level={2}>{lt('ContractsGenerateContractEmailTitle')}</Title>
            <SchemaFormFields
                schema={emailSchema}
                formDefinition={emailFormDefinition}
                namePrefix={`${GenerateContractFormStepName.Recipients}.${RecipientsFormFields.Email}`}
            />
        </Stack>
    );
};
